export class SearchResultStructuredData {
  #records;
  constructor(records) {
    this.#records = records;
  }

  /**
   * @param {any} record
   * @return {string}
   */
  #buildName(record) {
    return `${record["display-title-heading"]} ${record["display-title-info"].join(" ")} ${record["display-title-subheading"].join(" ")}`;
  }

  /**
   * @param {any} record
   * @return {OfferStructuredData}
   */
  #buildOfferStructuredData(record) {
    const priceInCents = record["price-eur"];
    const price =
      typeof priceInCents === "number" && !isNaN(priceInCents)
        ? (priceInCents / 100).toFixed(2)
        : "0.00";

    return {
      "@type": "Offer",
      price: price,
      priceCurrency: "EUR",
    };
  }

  /**
   * @return {BrandStructuredData}
   */
  #buildBrandStructuredData() {
    return {
      "@type": "Brand",
      name: "Cornelsen",
    };
  }

  /**
   * @param {any} record
   * @return {ProductStructuredData}
   */
  #buildProductStructuredData(record) {
    const product = {
      "@type": "Product",
      name: this.#buildName(record),
      url: record["detail-uri"],
      brand: this.#buildBrandStructuredData(),
      offers: this.#buildOfferStructuredData(record),
    };

    if (record["cover-uri"]) {
      product.image = [record["cover-uri"]];
    }

    return product;
  }

  /**
   * @param {number} position
   * @param {any} record
   * @return {ListItemStructuredData}
   */
  #buildListItemStructuredData(position, record) {
    return {
      "@type": "ListItem",
      position,
      item: this.#buildProductStructuredData(record),
    };
  }

  /**
   * @return {ItemListStructuredData}
   */
  #buildItemListStructuredData() {
    return {
      "@type": "ItemList",
      itemListElement: this.#records.map((record, index) => {
        return this.#buildListItemStructuredData(index + 1, record);
      }),
    };
  }

  /**
   * @param {string} url
   * @param {string} name
   * @return {SearchResultStructuredData}
   */
  getJsonLd(url, name) {
    return {
      "@context": "http://schema.org",
      "@type": ["WebPage", "CollectionPage"],
      url,
      name,
      inLanguage: "de",
      mainEntity: this.#buildItemListStructuredData(),
    };
  }
}
